import { styled, css } from "../../../../../../../styles";

// components

export const FormAnswerField = styled("div", {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  marginBottom: "20px",
  marginTop: "30px",

  variants: {
    isForms: {
      true: {
        alignItems: "flex-start",
      },
    },
  },
});

export const HorizontalSliderContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  width: "95%",
  marginTop: "20px",

  p: {
    textJustify: "inter-word",
    width: "30%",
  },
});

export const SliderContainer = styled("div", {
  width: "100%",
  alignSelf: "center",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "40px 0",
  touchAction: "none",
});

export const LabelsRow = styled("div", {
  alignSelf: "center",
  width: "92%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
});

export const LabelContainerLeft = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",

  width: "40%",

  fontWeight: "300",
  fontSize: "14px",
  lineHeight: "16px",
  textAlign: "left",
});

export const LabelContainerRight = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",

  width: "40%",

  fontWeight: "300",
  fontSize: "14px",
  lineHeight: "16px",
  textAlign: "right",
});

export const SliderValueHorizontal = styled("p", {
  width: "100% !important",
  fontFamily: "$openSans",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "16px",
  color: "#4B4B4B",
});

export const SliderLabelHorizontal = styled("p", {
  width: "100% !important",
  fontFamily: "$openSans",
  fontWeight: "300",
  fontSize: "16px",
  lineHeight: "16px",
  color: "#727272",
});

export const SliderValueVertical = styled("p", {
  fontFamily: "$openSans",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "16px",
  color: "#4B4B4B",
});

export const SliderLabelVertical = styled("p", {
  textAlign: "center",
  fontFamily: "$openSans",
  fontWeight: "300",
  fontSize: "16px",
  lineHeight: "16px",
  color: "#727272",
});

export const VerticalSliderContainer = styled("div", {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  minHeight: "300px",
  touchAction: "none",
  userSelect: "none",
  WebkitUserSelect: "none",

  p: {
    textJustify: "inter-word",
  },
});

export const SliderUsabilityMessage = styled("div", {
  marginTop: "40px",

  textAlign: "center",
  fontFamily: "$openSans",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "16px",
  color: "$charcoal",
});

export const verticalSliderCss = css({
  width: "200px !important",
  height: "98%!important",
  margin: "10px 11px",

  ".ant-slider": {
    width: "100% !important",
    touchAction: "none",
    "&:hover": {
      backgroundColor: "var(--colors-surveys-slider-trail) !important",
    },
  },

  ".ant-slider-rail": {
    backgroundColor: "var(--colors-surveys-slider-trail) !important",
    left: "97px",
    width: "5px",

    "&:hover": {
      backgroundColor: "var(--colors-surveys-slider-trail)",
    },
  },

  ".ant-slider-step": {
    left: " 98px",
  },
  ".ant-slider-handle": {
    boxShadow: "none",
    left: "93px",
    height: "13px",
    width: "13px",

    ".ant-tooltip": {
      pointerEvents: "none",
      inset: "auto auto -12px 23px !important",

      ".ant-tooltip-content": {
        fontSize: "16px",

        ".ant-tooltip-inner": {
          boxShadow: "none",
          padding: "4px 8px 6px 8px",
        },
      },
    },

    "&::after": {
      backgroundColor: "var(--colors-surveys-slider-dot) !important",
      boxShadow:
        "0 0 0 4px white, 0 0 0 6px color-mix(in srgb, var(--colors-surveys-slider-dot) 50%, white) !important",
      height: "13px",
      width: "13px",
      outline: "none !important",
    },
    "&::before": {
      zIndex: "1071",

      width: "75px",
      height: "44px !important",
      minHeight: "44px !important",

      insetInlineStart: "-16px",
      insetBlockStart: "-16px",
    },
    "&:focus": {
      "&::before": {
        zIndex: "1071",

        width: "75px",
        height: "44px !important",
        minHeight: "44px !important",

        insetInlineStart: "-16px",
        insetBlockStart: "-16px",
      },
      "&::after": {
        height: "13px",
        width: "13px",
        insetInlineStart: "0px !important",
        insetBlockStart: "0px !important",
      },
    },

    "&:hover": {
      "&::before": {
        zIndex: "1071",

        width: "75px",
        height: "44px !important",
        minHeight: "44px !important",

        insetInlineStart: "-16px",
        insetBlockStart: "-16px",
      },
      "&::after": {
        height: "13px",
        width: "13px",
        insetInlineStart: "0px !important",
        insetBlockStart: "0px !important",
      },
    },

    "&:active": {
      "&::before": {
        zIndex: "1071",

        width: "75px",
        height: "44px !important",
        minHeight: "44px !important",

        insetInlineStart: "-16px",
        insetBlockStart: "-16px",
      },
      "&::after": {
        height: "13px",
        width: "13px",
        insetInlineStart: "0px !important",
        insetBlockStart: "0px !important",
      },
    },
  },
});

export const horizontalSliderCss = css({
  margin: "0px !important",
  height: "50px !important",

  ".ant-slider": {
    padding: "20px 0",
    margin: "-20px 0",
    touchAction: "none",
  },

  ".ant-slider-rail": {
    backgroundColor: "var(--colors-surveys-slider-trail) !important",
    bottom: "22px",
    height: "5px",

    "&:hover": {
      backgroundColor: "var(--colors-surveys-slider-trail) !important",
    },
  },

  ".ant-slider-step": {
    top: "19px",
  },

  ".ant-slider-handle": {
    boxShadow: "none",
    top: "19px",
    height: "13px",
    width: "13px",

    ".ant-tooltip": {
      pointerEvents: "none",
      "--arrow-x": "16px !important",
      inset: "auto auto 22px -10px !important",

      ".ant-tooltip-arrow": {
        left: "16px !important",
      },
      ".ant-tooltip-content": {
        fontSize: "16px",
        ".ant-tooltip-inner": {
          boxShadow: "none",
        },
      },
    },

    "&::after": {
      backgroundColor: "var(--colors-surveys-slider-dot) !important",
      boxShadow:
        "0 0 0 4px white, 0 0 0 6px color-mix(in srgb, var(--colors-surveys-slider-dot) 50%, white) !important",
      height: "13px !important",
      width: "13px !important",
      outline: "none !important",
    },

    "&::before": {
      zIndex: "1071",

      width: "44px",
      height: "75px !important",
      minHeight: "75px !important",

      insetInlineStart: "-16px",
      insetBlockStart: "-50px",
    },

    "&:focus": {
      "&::before": {
        zIndex: "1071",

        width: "44px",
        height: "75px !important",
        minHeight: "75px !important",

        insetInlineStart: "-16px",
        insetBlockStart: "-50px",
      },
      "&::after": {
        height: "13px !important",
        width: "13px !important",
        insetInlineStart: "0px !important",
        insetBlockStart: "0px !important",
      },
    },

    "&:hover": {
      "&::before": {
        zIndex: "1071",

        width: "44px",
        height: "75px !important",
        minHeight: "75px !important",

        insetInlineStart: "-16px",
        insetBlockStart: "-50px",
      },
      "&::after": {
        height: "13px !important",
        width: "13px !important",
        insetInlineStart: "0px !important",
        insetBlockStart: "0px !important",
      },
    },

    "&:active": {
      "&::before": {
        zIndex: "1071",

        width: "44px",
        height: "75px !important",
        minHeight: "75px !important",

        insetInlineStart: "-16px",
        insetBlockStart: "-50px",
      },
      "&::after": {
        height: "13px !important",
        width: "13px !important",
        insetInlineStart: "0px !important",
        insetBlockStart: "0px !important",
      },
    },
  },
});

export const VerticalSliderInputContainer = styled("div", {
  height: "50%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",

  "@sm": {
    height: "98%",
  },
});

export const verticalSliderCssNoTooltip = css(verticalSliderCss, {
  ".ant-slider-handle": {
    "&::after": {
      backgroundColor: "transparent !important",
      boxShadow: "0 0 0 2px $gray-20 !important",
      height: "13px",
      width: "13px",
    },
    "&:focus": {
      "&::after": {
        backgroundColor: "transparent",
      },
    },
    "&:hover": {
      "&::after": {
        backgroundColor: "transparent",
      },
    },
    "&:active": {
      "&::after": {
        backgroundColor: "transparent",
      },
    },
  },
});

export const horizontalSliderCssNoTooltip = css(horizontalSliderCss, {
  ".ant-slider-handle": {
    "&::after": {
      backgroundColor: "transparent !important",
      boxShadow: "0 0 0 2px $gray-20 !important",
      height: "13px !important",
      width: "13px !important",
    },
    "&:focus": {
      "&::after": {
        backgroundColor: "transparent",
      },
    },
    "&:hover": {
      "&::after": {
        backgroundColor: "transparent",
      },
    },
    "&:active": {
      "&::after": {
        backgroundColor: "transparent",
      },
    },
  },
});
